<template>
  <app-select
    label="Caixa"
    v-bind="$attrs"
    :dense="dense"
    v-on="$listeners"
    :items="accounts"
    :item-text="itemText"
    :item-value="itemValue"
  />
</template>

<script>
export default {
  props: {
    itemText: {
      default() {
        return (val) => `${val.name}`;
      },
    },

    itemValue: {
      default() {
        return (val) => val;
      },
    },

    dense: {
      default: true,
    },
  },

  data : () => ({
    accounts : [],
  }),

  created() {
    this.select()
  },

  methods: {
    select() {
      this.$http.index('account/account').then((response) => {
        this.accounts = response.accounts;
      });
    },
  },
};
</script>

<style>
</style>